import request from '@/request'

// 根据authorization查询关联用户下infotikx平台账号
export function getUserByOtherPlatformAuthAPI(data) {
    return request({
        url: `/sso/getUserByOtherPlatformAuth`,
        method: 'post',
        data: data
    })
}

// 使用其他平台Token登录
export function ssoLoginAPI(data) {
    return request({
        url: `/sso/ssoLogin`,
        method: 'post',
        data: data
    })
}

// 使用其他平台Token登录
export function registerAndLoginAPI(data) {
    return request({
        url: `/sso/registerAndLogin`,
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/sso.js